import {
  Avatar,
  Box,
  Button,
  Container,
  FormControl,
  Grid,
  Link,
  Paper,
  TextField,
  styled,
  Typography,
  Chip,
  Divider,
} from "@mui/material";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import download from "downloadjs";
import ClearIcon from "@mui/icons-material/Clear";
import React, { useEffect, useRef, useState } from "react";
import AttachmentIcon from "@mui/icons-material/Attachment";
import QueryBreadcrumbs from "../../breadcrumbs/QueryBreadCrumbs";
import { useLocation, useNavigate } from "react-router";
import {
  queryThreadListService,
  queryAttacgedListService,
  saveQueryThreadDetails,
} from "../../services/queryServices";
import { useLoading } from "../../common/LoadingContext";
import { useNotificationContext } from "../../common/NotificationContext";
import AttachmentListPopup from "./AttachmentListPopup";
import { MessagesList } from "./MessageList";
import { ChatComponent } from "./ChatComponent";
import {
  converDateToDateTime,
  convertDateToDateTimeStringwithDash,
} from "../../utils/jsUtils";
import useGlobalState from "../../Context";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { CHAT_THREAD } from "../../utils/Validation";

const ChatThread = () => {
  const [{ userDetails }] = useGlobalState();
  const userParam = userDetails?.userParam;
  const location = useLocation();
  const { setLoading } = useLoading();
  const { showNotification } = useNotificationContext();
  const baseUrl = process.env.REACT_APP_BASE_URL;

  let navigate = useNavigate();
  const Input = styled("input")({
    display: "none",
  });
  const [rowsPerPage] = useState(10);

  const messagesEndRef = useRef(null);
  const virtuoso = useRef(null);

  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [queryRecord, setQueryRecord] = useState({});

  const formOption = {
    resolver: yupResolver(CHAT_THREAD),
  };
  const {
    register,
    handleSubmit,
    reset,

    formState: { errors },
  } = useForm(formOption);
  const [communicationArray, setCommunicationArray] = useState([]);
  const [communicationResponseSize, setCommunicationResponseSize] = useState(0);
  const [latestTimeStamp, setLatestTimeStamp] = useState("");
  const [downloadFileList, setDownloadFileList] = useState([]);

  const initialLoad = async () => {
    if (location && location.state) {
      const state = location.state;
      if (state.queryRecord) {
        setQueryRecord(state.queryRecord);
        const currentDateObj = new Date();

        await getQueryThreadList(
          state.queryRecord?.queryId,
          converDateToDateTime(currentDateObj) + ".000",
          true
        );
        await getQueryAttachmentList(state.queryRecord?.queryId);
      }

      window.history.replaceState({}, document.title);
    } else {
      navigate("/raise-query", { replace: true });
    }
  };

  const onImageChange = (event) => {
    if (
      event.target.files === null ||
      event.target.files === undefined ||
      event.target.files.length === 0
    ) {
      setUploadedFiles(null);
    } else {
      let pattern = /image-*/;
      if (!event?.target?.files[0]?.type?.match(pattern)) {
        showNotification("Error", "Invalid type selected, Please try again.");
        setUploadedFiles(null);
      } else {
        if (event.target.files[0].size >= 10485760) {
          showNotification(
            "Error",
            "File too Big, please select a file less than 10mb"
          );
          setUploadedFiles(null);
        } else {
          setUploadedFiles(event.target.files);
        }
      }
    }
  };
  const scrollToBottom = () => {
    messagesEndRef?.current?.scrollIntoView({
      behavior: "smooth",
      block: "end",
    });
    const element = document.getElementById("scrollContainer");

    element?.scroll({ top: element.scrollHeight, behavior: "smooth" });
  };

  useEffect(() => {
    initialLoad();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const getQueryThreadList = async (id, timeStamp, firstCheck = false) => {
    try {
      setLoading(true);

      const queryThreadListResponse = await queryThreadListService(baseUrl, {
        queryId: id,

        pageParam: {
          pageSize: rowsPerPage,
          lastTimestamp: timeStamp,
        },
      });
      if (queryThreadListResponse?.messageCode === 6) {
        if (
          queryThreadListResponse?.queryThreadPage &&
          queryThreadListResponse?.queryThreadPage?.content
        ) {
          const responseArray =
            queryThreadListResponse?.queryThreadPage?.content?.reverse();
          setCommunicationArray((prevValue) => {
            return [...responseArray, ...prevValue];
          });
          setLatestTimeStamp(queryThreadListResponse?.lastTimeStamp);
          if (firstCheck) {
            setCommunicationResponseSize(
              queryThreadListResponse?.queryThreadPage?.totalElements
            );
          }
        }
      }
    } catch (err) {
      showNotification(
        "Error",
        err?.message ?? "Failed To Fetch List Query Type Details"
      );
    } finally {
      setLoading(false);
    }
  };
  const getQueryAttachmentList = async (id) => {
    try {
      setLoading(true);
      const queryAttachedFilelistResponse = await queryAttacgedListService(
        baseUrl,
        { referenceId: id }
      );
      if (queryAttachedFilelistResponse) {
        setDownloadFileList(queryAttachedFilelistResponse?.documentParamList);
      } else {
        showNotification(
          "Error",
          queryAttachedFilelistResponse?.message ??
            "Failed To Fetch Attachment List "
        );
      }
    } catch (err) {
      showNotification(
        "Error",
        err?.message ?? "Failed To Fetch Attachment List "
      );
    } finally {
      setLoading(false);
    }
  };

  const stringAvatar = (name) => {
    return {
      sx: {
        bgcolor: "#4ac2a9",
        color: "white",
      },
      children: `${!!name.split(" ")[0][0] ? name.split(" ")[0][0] : ""} ${
        !!name?.split(" ")[1][0] ? name?.split(" ")[1][0] : ""
      }`,
    };
  };

  const onSubmit = async (data) => {
    try {
      setLoading(true);

      const requestBody = {
        queryId: queryRecord?.queryId,
        comment: data?.userMessage,
        is_attachment: uploadedFiles?.length > 0 ? true : false,
        userType: "Vendor",
        userName: userParam?.firstName + " " + userParam?.lastName,
        file: uploadedFiles[0],
      };
      const saveQueryThreadResponse = await saveQueryThreadDetails(
        baseUrl,
        requestBody
      );
      if (saveQueryThreadResponse.messageCode === 6) {
        await setCommunicationArray((prevArr) => [
          ...prevArr,
          {
            userName: userParam?.email,
            is_attachment: uploadedFiles?.length > 0 ? "true" : "false",
            comment: data?.userMessage,
            attachments: uploadedFiles,
            userType: "Vendor",
            createdDate: new Date(),
          },
        ]);
        if (communicationArray?.length !== 0) {
          await scrollToBottom();
          await virtuoso?.current?.scrollToIndex({
            index: communicationResponseSize,
            align: "start",
            behavior: "smooth",
          });
        }
        if (uploadedFiles?.length > 0) {
          await getQueryAttachmentList(queryRecord?.queryId);
        }

        reset({ userMessage: "" });
        setUploadedFiles([]);
      }
    } catch (err) {
      showNotification("Error", err?.message ?? "Failed To Add Message");
    } finally {
      setLoading(false);
    }
  };

  const createdDate = new Date(queryRecord?.createdDate);

  return (
    <>
      <Container maxWidth="xl" sx={{ mt: 8, px: 1 }} disableGutters>
        <Box ml={3}>
          <QueryBreadcrumbs />
        </Box>{" "}
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <Grid item xs={12} mb={5} sx={{ pl: 3, pr: 3, mt: 2 }}>
            <Paper elevation={3} variant="elevation">
              <Grid container display={"flex"}>
                <Grid xs={12} item display={"flex"} sx={{ m: 2 }}>
                  <Grid item>
                    <Avatar
                      style={{
                        width: "50px",
                        height: "50px",
                        fontSize: "20px",
                      }}
                      {...stringAvatar(queryRecord?.userName + " ")}
                    />
                  </Grid>
                  <Grid xs={11} item mx={3}>
                    <Grid
                      item
                      display="flex"
                      alignItems={"center"}
                      justifyContent={"space-between"}
                    >
                      <Box sx={{ mt: 0.5, textAlign: "left" }}>
                        <div className="pageHeader">
                          {queryRecord?.userName}
                        </div>
                        <div style={{ fontSize: "12px" }}>
                          <span>Raised on: </span>
                          <span>
                            {convertDateToDateTimeStringwithDash(createdDate)}
                          </span>
                        </div>
                      </Box>
                      <Box>
                        <div>
                          <span style={{ fontSize: "12px" }}>Query Id:</span>
                          <span style={{ fontSize: "12px" }}>
                            {queryRecord?.queryId}
                          </span>
                          {queryRecord?.status === 10 ? (
                            <Chip label="Open" sx={{ ml: 1 }} color="primary" />
                          ) : (
                            <Chip label="Close" sx={{ ml: 1 }} color="error" />
                          )}
                        </div>
                      </Box>
                    </Grid>
                    <Grid item sx={{ mt: 3, textAlign: "left" }}>
                      <div className="pageHeader">
                        {" "}
                        {queryRecord?.["queryType"]?.type}
                      </div>
                      <div
                        style={{
                          fontSize: "13px",

                          marginTop: "5px",
                          marginBottom: "15px",
                          display: "flex",
                        }}
                      >
                        <div>{queryRecord?.["querySubType"]?.subType}</div>
                        <AttachmentListPopup Filelist={downloadFileList} />
                      </div>
                    </Grid>

                    <Grid item textAlign={"left"} sx={{ my: 1, width: "100%" }}>
                      <Typography
                        variant="body1"
                        sx={{ color: "gray", fontSize: "13px" }}
                      >
                        {queryRecord?.comment}
                      </Typography>
                    </Grid>
                    <Box bgcolor={"#dfe3e9"} maxHeight={"440px"}>
                      <Divider />
                      <Grid
                        id="scrollContainer"
                        my={3}
                        overflow="auto"
                        mb={1}
                        item
                        borderRadius={"5px"}
                      >
                        {communicationArray?.length ? (
                          <>
                            <MessagesList
                              messages={communicationArray}
                              startReached={() => {
                                getQueryThreadList(
                                  queryRecord?.queryId,
                                  latestTimeStamp
                                );
                              }}
                              virtuoso={virtuoso}
                              startIndex={communicationResponseSize}
                            />
                          </>
                        ) : (
                          <Box sx={{ px: 1 }}>
                            <ChatComponent
                              userName={"System"}
                              message={
                                "Your query has been raised, someone will reply to your query shortly. If you want to add more information you can add it from below text field."
                              }
                              type={"FC"}
                              createdDate={queryRecord?.createdDate}
                            />
                          </Box>
                        )}
                      </Grid>
                    </Box>
                    <Grid container xs={10} mt={3}>
                      {uploadedFiles &&
                        Array.from(uploadedFiles).map((imageElement) => {
                          return (
                            <Grid item>
                              <Box mx={0.5} display={"flex"}>
                                <Link
                                  onClick={() => {
                                    download(imageElement, imageElement.name);
                                  }}
                                  variant="body2"
                                >
                                  {imageElement.name}
                                </Link>
                                <ClearIcon
                                  fontSize="small"
                                  color="error"
                                  onClick={() => {
                                    setUploadedFiles(
                                      Array.from(uploadedFiles).filter(
                                        (image) => {
                                          return (
                                            image.name !== imageElement.name
                                          );
                                        }
                                      )
                                    );
                                  }}
                                />
                              </Box>
                            </Grid>
                          );
                        })}
                    </Grid>
                    {queryRecord?.status === 11 ? (
                      <Box>
                        <Box display={"flex"} justifyContent="center">
                          <TaskAltIcon sx={{ mr: 1, color: "#8250df" }} />
                          <Typography fontWeight={500}>
                            This thread was marked as resolved by FC
                          </Typography>
                        </Box>
                      </Box>
                    ) : (
                      <>
                        <Box
                          display={"flex"}
                          alignItems={"start"}
                          sx={{
                            position: "sticky",
                            bottom: "0px",
                            background: "#fff",
                            p: 1,
                            pt: 2,
                          }}
                        >
                          <FormControl fullWidth>
                            <TextField
                              id=""
                              placeholder="Reply"
                              name="userMessage"
                              className="input-correction"
                              {...register("userMessage", { required: true })}
                              size="small"
                              inputProps={{
                                maxLength: 100,
                              }}
                              InputProps={{
                                endAdornment: (
                                  <label htmlFor="contained-button-file">
                                    <Input
                                      accept="image/png, image/jpg, image/jpeg"
                                      id="contained-button-file"
                                      multiple
                                      type="file"
                                      onChange={onImageChange}
                                    />
                                    <Button component="span">
                                      <AttachmentIcon />
                                    </Button>
                                  </label>
                                ),
                              }}
                              error={Boolean(errors?.userMessage)}
                              helperText={errors?.userMessage?.message}
                            ></TextField>
                          </FormControl>

                          <Button
                            sx={{ ml: 3, color: "white" }}
                            variant="contained"
                            onClick={handleSubmit(onSubmit)}
                          >
                            Submit
                          </Button>
                        </Box>
                        <Box display="flex" justifyContent={"end"}>
                          <Typography
                            variant="caption"
                            color={"primary"}
                            fontStyle={"italic"}
                          >
                            * You can only upload <b>jpg, png, jpeg</b> files.{" "}
                            <br></br>* Maximum upload file size - <b>10 mbs.</b>
                          </Typography>
                        </Box>
                      </>
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </Container>
      <div ref={messagesEndRef}></div>
    </>
  );
};

export default ChatThread;
